import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((cfg) => {
  const role = cfg.headers?.["X-Auth-Role"] || "admin";
  delete cfg.headers["X-Auth-Role"];
  const key = role === "client" ? "gb_portal_token" : "gb_admin_token";
  const t = localStorage.getItem(key);
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export default api;

export const getUTM = () => {
  const params = new URLSearchParams(window.location.search);
  return {
    utm_source: params.get("utm_source") || "",
    utm_medium: params.get("utm_medium") || "",
    utm_campaign: params.get("utm_campaign") || "",
  };
};

export const trackPageview = async (page) => {
  try {
    const fd = new FormData();
    fd.append("page", page);
    fd.append("referrer", document.referrer || "");
    await axios.post(`${API_BASE}/track/pageview`, fd);
  } catch (_) {}
};
